import api from '../../api/withdrawals'
import toastr from 'toastr'
import { LogError } from '@/util/responseHandler'
import { notification } from '@/util/notification'

export default {

    async all({commit},currency){
        try {
            commit('loading',null,{root:true})
            const res = await api.all(currency)
            if(res && res.status==200){
                commit('withdrawals',res.data.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res
        } catch (error) {
            LogError(commit,error,'loaded')
        }
    },

    async searchWithdrawals({commit},{query,page=null}){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.search(query,page)
            if(res.status==200){
                commit('withdrawals',res.data.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async getUserPendingWithdrawals({commit},uuid){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.userPendingWithdrawals(uuid)
            if(res.status==200){
                commit('userPendingWithdrawals',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async getDetails({commit},id){
        try {
            commit('loading',null,{root:true})
            const res = await api.details(id)
            if(res && res.status==200){
                commit('withdrawal',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (error) {
            LogError(commit,error,'loaded')
        }
    },

    async initiate({commit},{uuid,data}){
        var res;
        try {
            commit('submitting',null,{root:true})
            res = await api.initiate(uuid,data)
            if(res.status==200){
                notification.success("Withdrawal Request successful")
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res
        } catch (err) {
            LogError(commit,err,'submitted')
        }
    },

    async getTotal({commit},currency){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.total(currency)
            if(res.status==200){
                commit('totalWithdrawals',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async getUserTotal({commit},uuid){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.userTotal(uuid)
            if(res.status==200){
                commit('userTotalWithdrawals',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async getUserHistory({commit},uuid){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.userHistory(uuid)
            if(res.status==200){
                commit('userWithdrawals',res.data.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async payWithWallet({commit},data){
        var res;
        try {
            //commit('loading',null,{root:true})
            res = await api.payWithWallet(data)
            if(res.status==200){
                //commit('userWithdrawals',res.data.data.data)
                toastr.success(res.data.message)
            }else{
                toastr.warning(res.data.message)
            }
            //commit('loaded',null,{root:true})
            return res
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    }

    
}